import React from 'react';
import GenericErrorPage from './GenericErrorPage';

const Maintenance = () => (
	<GenericErrorPage
		title="Down for Maintenance"
		paragraphs={[
			"Sorry, but we've had to briefly shut down to fix a few things.",
			'Please try again soon.',
		]}
	/>
);

export default Maintenance;
